
import { useState } from 'react';
import { useToast } from '@/hooks/use-toast';

export const useFileUploads = () => {
  const [uploadedFiles, setUploadedFiles] = useState<File[]>([]);
  const [isUploading, setIsUploading] = useState(false);
  const { toast } = useToast();

  const handleFileUpload = (files: FileList | null) => {
    if (files && files.length > 0) {
      setIsUploading(true);
      setTimeout(() => {
        const newFiles = Array.from(files);
        setUploadedFiles(prev => [...prev, ...newFiles]);
        setIsUploading(false);
      }, 1000);
    }
  };

  const removeFile = (index: number) => {
    setUploadedFiles(prev => prev.filter((_, i) => i !== index));
  };

  return {
    uploadedFiles,
    setUploadedFiles,
    isUploading,
    setIsUploading,
    handleFileUpload,
    removeFile
  };
};
